import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import ShowMore from 'react-show-more';
import { variables } from 'components/theme';

import { itemTextColor } from 'utils/theme';

const styles = css`
  color: ${itemTextColor} !important;
  text-decoration: underline;
  font-family: ${variables.fonts.openSansSemiBold};
`;

const Wrapper = styled.div`
  height: auto;
  width: ${({ width }) => (width ? width : 'auto')};
  font-size: 14px !important;

  .showMore {
    ${styles}
  }

  span,
  p,
  a {
    line-height: 1.5 !important;
    font-family: 'Open Sans', sans-serif !important;
    font-weight: 600 !important;
    font-style: normal !important;
    font-size: 14px !important;
    color: ${itemTextColor} !important;
  }

  o:p {
    display: none !important;
  }

  a {
    text-decoration: underline;
    font-weight: 400 !important;
  }

  @media screen and (max-width: 576px) {
    line-height: 22px;
    margin-bottom: 84px;
    font-size: 12px !important;

    span,
    p,
    a {
      font-size: 14px !important;
    }
  }
`;

function Description({ description, lines, ...rest }) {
  return (
    <Wrapper {...rest}>
      <ShowMore
        lines={lines || 3}
        more="Read more"
        less="Read less"
        anchorClass="showMore"
      >
        {parse(`${description}`)}
      </ShowMore>
    </Wrapper>
  );
}

Description.propTypes = {
  description: PropTypes.node
};

export default Description;
